import { defineMessages } from 'react-intl';

const scope = 'app.workspace.cohorts.grades';

export default defineMessages({
  title: {
    id: `${scope}.title`,
    defaultMessage: 'Grades & Progress',
  },
});
